/**
 * Shared "Back" handler for detail pages.
 *
 * If the visitor arrived directly (fresh tab, bookmark, refresh), React Router
 * gives `location.key === "default"` — in that case we fall back to Landing so
 * the browser Back doesn't accidentally leave the app.
 *
 * Otherwise we pop the SPA history by one entry.
 */
import { useLocation, useNavigate } from "react-router-dom";

export function useGoBack(fallback = "/") {
    const location = useLocation();
    const navigate = useNavigate();
    return () => {
        if (location.key === "default") navigate(fallback, { replace: true });
        else navigate(-1);
    };
}
